module.exports = __webpack_public_path__ + "media/images/icon_list/dots_vertical-a4598e49297dd2fc32f39b327606cf5b.svg";